export const APPLY_CREDIT_DECISION = 'APPLY_CREDIT_DECISION';
export const OPEN_CREDIT_DECISION_SLIDEOUT = 'OPEN_CREDIT_DECISION_SLIDEOUT';
export const CLOSE_CREDIT_DECISION_SLIDEOUT = 'CLOSE_CREDIT_DECISION_SLIDEOUT';
export const GET_CREDIT_APP_DATA_REQUEST = 'GET_CREDIT_APP_DATA_REQUEST';
export const GET_CREDIT_APP_DATA_SUCCESS = 'GET_CREDIT_APP_DATA_SUCCESS';
export const GET_CREDIT_APP_DATA_FAILURE = 'GET_CREDIT_APP_DATA_FAILURE';
